const widgetCardSurfaceClassName =
  'relative flex h-auto min-w-0 w-full @container flex-col overflow-visible rounded-xl';

export const widgetCardClassName = `${widgetCardSurfaceClassName} border border-slate-200 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]`;

export const widgetDropTargetCardClassName =
  'relative flex h-auto flex-col overflow-hidden rounded-xl border-2 border-bzblue-700 bg-bzblue-100';

export const widgetHeaderClassName =
  'flex shrink-0 items-center justify-between gap-2 border-b border-slate-200 px-5 py-3';

export const widgetTitleClassName = 'text-base font-extrabold tracking-tight text-slate-950';

export const widgetBodyClassName = 'flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden p-4';

export const widgetEmptySurfaceClassName =
  'flex w-full min-w-0 max-w-full flex-col items-center justify-center gap-6 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-6 text-center break-words';

export const widgetEmptyClassName = `${widgetEmptySurfaceClassName} min-h-52 flex-1 py-12`;

export const widgetInputClassName =
  'min-h-9 w-full rounded-md border border-slate-200 py-1.5 text-sm text-slate-950 placeholder:text-slate-400 outline-none transition-[border-color] duration-150 ease-out focus:border-bzblue-700';

export const widgetCheckboxInputClassName = 'peer absolute inset-0 z-10 cursor-pointer opacity-0 outline-none';

export const widgetCheckboxMarkClassName = (checked: boolean) =>
  `pointer-events-none flex size-4 items-center justify-center rounded-[4px] border transition-[border-color,background-color,color] duration-150 ease-out peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-bzblue-700 ${
    checked
      ? 'border-[#3F83F8] bg-[#3F83F8] text-white'
      : 'border-slate-300 bg-white text-transparent group-hover:border-slate-400'
  }`;

export const alertsFilterToolbarClassName = 'flex w-full min-w-0 items-center gap-2';

export const alertsFilterCountClassName =
  'inline-block min-w-[2ch] text-center tabular-nums font-semibold';

export const widgetGhostButtonClassName =
  'inline-flex min-h-9 items-center gap-1.5 rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 transition-[border-color,background-color,color,opacity] duration-150 ease-out hover:border-slate-300 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bzblue-700 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-slate-200 disabled:hover:bg-white';

export const widgetAccentButtonClassName =
  'inline-flex min-h-9 items-center gap-1.5 rounded-md border border-bzblue-400 bg-white px-3 py-1.5 text-sm font-semibold text-bzblue-700 transition-[border-color,background-color,color] duration-150 ease-out hover:border-bzblue-700 hover:bg-bzblue-100 hover:text-bzblue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bzblue-700';

export const alertsToolbarButtonClassName = `${widgetGhostButtonClassName} relative size-9 shrink-0 justify-center px-0`;

export const alertsToolbarButtonActiveClassName = `${widgetAccentButtonClassName} relative size-9 shrink-0 justify-center px-0`;

export const widgetIconButtonClassName =
  'rounded-md p-1.5 text-slate-400 transition-colors duration-150 ease-out hover:bg-bzblue-100 hover:text-slate-700';

export const widgetTextLinkClassName =
  'inline-flex items-center gap-1 text-sm font-bold text-bzblue-700 transition-colors duration-150 ease-out hover:text-bzblue-800';

export const widgetPrimaryButtonClassName =
  'inline-flex min-h-9 items-center gap-1.5 rounded-md bg-bzblue-700 px-3 py-1.5 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-bzblue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bzblue-700';

export const widgetRowHoverClassName =
  'transition-[background-color,border-color] duration-150 ease-out hover:bg-bzblue-100';

export const widgetMenuPanelClassName = 'rounded-xl border border-slate-200 bg-white p-1.5 shadow-xl';

export const widgetMenuItemClassName = `flex min-h-10 w-full items-center rounded-md px-3 py-2 text-left text-sm ${widgetRowHoverClassName}`;

export const widgetDragHandleClassName =
  'edge-widget-drag-handle flex touch-none cursor-grab items-center text-slate-400 select-none hover:text-slate-600 active:cursor-grabbing';
